import { t } from "i18next";
import { useCallback } from "react";

export function useTranslationPath(path: string) {
  const translation = useCallback((key: string) => t(`${path}.${key}`), [path]);

  return translation;
}
